module.exports = __webpack_public_path__ + "img/vinyl.2f820426.png";